/* tslintdisableno-console */
import Backbone from 'backbone'
// import $ from 'jquery'
import _ from 'underscore'
import tmpl from '../template/tmpl.html'

class AlertView extends Backbone.View {
    events () {
        return {
            'click .close': 'close'
        }
    }

    initialize (options) {
        this._tmpl = _.template(tmpl)
    }

    render () {
        try {
            if (!this.model.isValid()) {
                throw new Error(this.model.validationErrors)
            }

            const model = this.model.toJSON()
            this.$el.html(this._tmpl(model))

            return this.$el
        } catch (ex) {
            console.error(ex)
        }
    }

    close (ev) {
        ev.preventDefault()
        ev.stopPropagation()

        this.$el.remove()
    }

    set (data) {
        try {
            this.model.set(data)

            if (!this.model.isValid()) {
                throw new Error(this.model.validationErrors)
            }
        } catch (ex) {
            console.error(ex)
        }
    }
}

export default AlertView
